import { render, staticRenderFns } from "./AegCaseCommercialBlock.vue?vue&type=template&id=2a8f7591"
import script from "./AegCaseCommercialBlock.vue?vue&type=script&lang=js"
export * from "./AegCaseCommercialBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports